import { combineReducers } from "redux";
import {
  DEFAULT_STATE,
  DEFAULT_STATE_FF_EF,
  sidebarToggleItems
} from "../utility/constants";
import moment from "moment";

const createReducer = (reducerName, defaultStateParam) => {
  const defaultState = defaultStateParam || DEFAULT_STATE;
  return (state = defaultState, action) => {
    switch (action.type) {
      case `${reducerName}_PENDING`:
      case `${reducerName}_FULFILLED`:
      case `${reducerName}_REJECTED`:
        return Object.assign({}, action.payload);
      default:
        return state;
    }
  };
};

const createStaticReducer = (reducerName, defaultStateParam) => {
  const defaultState = defaultStateParam || DEFAULT_STATE;
  return (state = defaultState, action) => {
    switch (action.type) {
      case `${reducerName}`:
        return Object.assign({}, action.payload);
      default:
        return state;
    }
  };
};

const rootReducer = combineReducers({
  sidebar: createStaticReducer("TOGGLE_SIDEBAR", {
    visible: true
  }),
  sidebarMenuToggle: createStaticReducer(
    "TOGGLE_SIDEBAR_MENU",
    sidebarToggleItems
  ),

  loginSection: createStaticReducer("LOGIN_SECTION", {
    loginType: "email"
  }),

  enterEmail: createReducer("ENTER_EMAIL", DEFAULT_STATE_FF_EF),
  verifyOTP: createReducer("VERIFY_OTP", DEFAULT_STATE_FF_EF),
  otpCreation: createReducer("OTP_CREATION", DEFAULT_STATE_FF_EF),
  createPassword: createReducer("CREATE_PASSWORD", DEFAULT_STATE_FF_EF),
  enterPassword: createReducer("ENTER_PASSWORD", DEFAULT_STATE_FF_EF),

  logout: createReducer("LOGOUT", {
    logout: false
  }),

  countries: createReducer("GET_COUNTRIES", DEFAULT_STATE_FF_EF),
  districts: createReducer("GET_DISTRICTS", DEFAULT_STATE_FF_EF),

  currentTab: createStaticReducer("CURRENT_TAB", {
    currentTab: "Accepted trips"
  }),

  bookingAdd: createReducer("BOOKING_ADD", DEFAULT_STATE_FF_EF), //
  b2bBookingsById: createReducer("B2B_BOOKINGS_BY_ID", DEFAULT_STATE_FF_EF), //
  getBusinessUsers: createReducer("BUSINESS_USER_GET", DEFAULT_STATE_FF_EF),

  getLocationHistory: createReducer(
    "GET_LOCATION_HISTORY",
    DEFAULT_STATE_FF_EF
  ), //
  updatePickupLocation: createReducer(
    "UPDATE_PICKUP_LOCATION",
    DEFAULT_STATE_FF_EF
  ), //
  vehicleTypes: createReducer("GET_VEHICLE_TYPES", DEFAULT_STATE_FF_EF), //

  settingsConfig: createReducer("GET_SETTINGS_CONFIG", DEFAULT_STATE_FF_EF),

  admins: createReducer("GET_ADMINS", DEFAULT_STATE_FF_EF),
  adminAdd: createReducer("ADMIN_ADD", DEFAULT_STATE_FF_EF),
  adminDelete: createReducer("ADMIN_DELETE", DEFAULT_STATE_FF_EF),
  employees: createReducer("GET_EMPLOYEES", DEFAULT_STATE_FF_EF),
  employeeAdd: createReducer("EMPLOYEES_ADD", DEFAULT_STATE_FF_EF),
  configCheck: createReducer("CONFIG_CHECK", DEFAULT_STATE_FF_EF),
  pendingList: createReducer("GET_PENDING_LIST", DEFAULT_STATE_FF_EF),
  inProgressListEts: createReducer(
    "GET_INPROGRESS_LIST_ETS",
    DEFAULT_STATE_FF_EF
  ),
  completedListEts: createReducer(
    "GET_COMPLETED_LIST_ETS",
    DEFAULT_STATE_FF_EF
  ),
  inProgressList: createReducer("GET_INPROGRESS_LIST", DEFAULT_STATE_FF_EF),
  completedList: createReducer("GET_COMPLETED_LIST", DEFAULT_STATE_FF_EF),
  corporateApiList: createReducer(
    "GET_CORPORATE_API_LIST",
    DEFAULT_STATE_FF_EF
  ),
  corporateApiDetails: createReducer(
    "GET_CORPORATE_API_DETAILS",
    DEFAULT_STATE_FF_EF
  ),
  apiToken: createReducer("GET_ API_TOKEN", DEFAULT_STATE_FF_EF),
  tripListDetail: createReducer("GET_TRIP_DETAILS", DEFAULT_STATE_FF_EF),
  etsTripListDetail: createReducer("GET_ETS_TRIP_DETAILS", DEFAULT_STATE_FF_EF),
  etsVehicleInfo: createReducer("GET_ETS_VEHICLE_INFO", DEFAULT_STATE_FF_EF),
  bookingsStatus: createReducer("GET_BOOKING_STATUS", DEFAULT_STATE_FF_EF),
  updateBookingsStatus: createReducer(
    "UPDATE_TRIP_DETAILS",
    DEFAULT_STATE_FF_EF
  ),
  updateBookingDetails: createReducer(
    "UPDATE_BOOKING_DETAILS",
    DEFAULT_STATE_FF_EF
  ),

  superAdmins: createReducer("GET_SUPER_ADMINS", DEFAULT_STATE_FF_EF),
  superAdminAdd: createReducer("SUPER_ADMIN_ADD", DEFAULT_STATE_FF_EF),
  superAdminDelete: createReducer("SUPER_ADMIN_DELETE", DEFAULT_STATE_FF_EF),

  addCSV: createReducer("ADD_CSV", DEFAULT_STATE_FF_EF),

  tripSheetData: createReducer("GET_TRIP_SHEET", DEFAULT_STATE_FF_EF),
  tripSheetGeneralData: createReducer(
    "GET_TRIP_SHEET_GENERAL",
    DEFAULT_STATE_FF_EF
  ),
  tripListFilters: createStaticReducer("TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: ""
  }),
  driverTrackingDetailB2b: createReducer(
    "DRIVER_TRACKING_DETAILS_B2B",
    DEFAULT_STATE_FF_EF
  ),
  driverTrackingDirection: createReducer(
    "DRIVER_TRACKING_DIRECTION",
    DEFAULT_STATE_FF_EF
  ),
  employeeDetail: createReducer("GET_EMPLOYEE_DETAILS", DEFAULT_STATE_FF_EF),

  googleCustomPlaces: createReducer(
    "GOOGLE_CUSTOM_PLACES",
    DEFAULT_STATE_FF_EF
  ),
  distanceMatrix: createReducer("GET_DISTANCE_MATRIX", DEFAULT_STATE_FF_EF),
  placesDetail: createReducer("GET_PLACES_DETAIL", DEFAULT_STATE_FF_EF),
});

export default rootReducer;
